import React, { CSSProperties, useLayoutEffect } from 'react';
import ReactModal from 'react-modal';
import cn from 'classnames';

import { REACT_ROOT_ID } from '@/config/common.config';
import useDisableBodyScroll from '@/hooks/useToggleBodyScroll.hook';
import styles from './modal-window.module.scss';

ReactModal.setAppElement(`#${REACT_ROOT_ID}`);

export interface IModalWindowProps {
  isOpen: boolean;
  children: any;
  contentStyle?: CSSProperties;
  borderAccent?: string;
  onClose: () => void;
  style?: ReactModal.Props['style'];
}

export default function ModalWindow({
  isOpen,
  children,
  contentStyle,
  borderAccent,
  onClose,
  style
}: IModalWindowProps) {
  const { toggleBodyScroll } = useDisableBodyScroll();

  useLayoutEffect(() => {
    if (isOpen) {
      toggleBodyScroll(false);
    }

    return () => toggleBodyScroll(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <ReactModal
      onRequestClose={onClose}
      isOpen={isOpen}
      className={styles['modal-window']}
      overlayClassName={styles['modal-overlay']}
      style={style}
    >
      <div className={cn('global-scope', styles['scrollable-wrapper'])}>
        <div className={styles['content-wrapper']} style={contentStyle}>
          <div
            className={styles['border-accent']}
            style={{ borderTopColor: borderAccent }}
          />
          {children}
        </div>
      </div>
    </ReactModal>
  );
}
